export default __webpack_public_path__ + "static/media/TotalEggs.c6a62eb6.jpg";